// The Schedules page's one list (docs/tasks/build-spec.md §9.3,
// routes/schedule_overview.py): task schedules, workflow timetables and the
// agents' routines, read-only, in one response. Routines that could not be
// read fill `routines_error`; the other rows still come back. A failed read
// (a 503 included) is "did not load", never an empty list. Polled every
// 30 s (nothing here is live). Types: generated (src/types/api.gen.ts).

import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { components } from "@/types/api.gen";

export type ScheduleOverview = components["schemas"]["ScheduleOverview"];
export type ScheduleRowOut = components["schemas"]["ScheduleRowOut"];
export type ScheduleSource = ScheduleRowOut["source"];

export const scheduleOverviewKey = (c: string | null) => ["schedule-overview", c] as const;

export function useScheduleOverview(customerId: string | null) {
  return useQuery({
    queryKey: scheduleOverviewKey(customerId),
    enabled: !!customerId,
    queryFn: ({ signal }) => apiFetch<ScheduleOverview>(`/api/customers/${encodeURIComponent(customerId!)}/schedule-overview`, { signal }),
    staleTime: 5_000,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
}
